exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-flow-diagram-modal .flow-diagram-modal-container{height:100%}.fts-flow-diagram-modal .flow-diagram-emoji{height:1.75rem;display:flex;align-items:center}", ""]);

// exports
